module.exports = __webpack_public_path__ + "static/media/CombinedShape.c3755e31.svg";